export const UNIFIED_ALERTS_SOURCE_IDS = ['0,1,6', '4', '2,3', '5'];
export const SMART_ASSESSMENT_SOURCE_IDS = [
  '0,1,6',
  '4',
  '2,3',
  '5',
  '10',
  '11',
  '12',
  '13',
  '14',
  '18',
  '19',
  '21'
];
